import MuiAutocomplete from './MuiAutoComplete';
import MuiButton from './MuiButton';
import MuiButtonBase from './MuiButtonBase';
import MuiCheckbox from './MuiCheckbox';
import MuiChip from './MuiChip';
import MuiCssBaseline from './MuiCssBaseline';
import MuiDateCalendar from './MuiDateCalendar';
import MuiDayCalendar from './MuiDayCalendar';
import MuiDialog from './MuiDialog';
import MuiDialogActions from './MuiDialogActions';
import MuiDialogContent from './MuiDialogContent';
import MuiDialogTitle from './MuiDialogTitle';
import MuiDrawer from './MuiDrawer';
import MuiFormControlLabel from './MuiFormControlLabel';
import MuiFormHelperText from './MuiFormHelperText';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiInputLabel from './MuiInputLabel';
import MuiLink from './MuiLink';
import MuiListItemButton from './MuiListItemButton';
import MuiListItemIcon from './MuiListItemIcon';
import MuiMenu from './MuiMenu';
import MuiMenuItem from './MuiMenuItem';
import MuiMonthCalendar from './MuiMonthCalendar';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiPickersDay from './MuiPickersDay';
import MuiPickersMonth from './MuiPickersMonth';
import MuiPopover from './MuiPopover';
import MuiRadio from './MuiRadio';
import MuiSelect from './MuiSelect';
import MuiSwitch from './MuiSwitch';
import MuiTab from './MuiTab';
import MuiTabs from './MuiTabs';
import MuiTextField from './MuiTextField';

export default {
	MuiCssBaseline,
	MuiButton,
	MuiButtonBase,
	MuiInputBase,
	MuiOutlinedInput,
	MuiLink,
	MuiTabs,
	MuiTab,
	MuiPaper,
	MuiChip,
	MuiSelect,
	MuiMenuItem,
	MuiDialog,
	MuiDialogContent,
	MuiTextField,
	MuiFormControlLabel,
	MuiFormHelperText,
	MuiAutocomplete,
	MuiDialogActions,
	MuiDialogTitle,
	MuiIconButton,
	MuiDateCalendar,
	MuiDayCalendar,
	MuiMenu,
	MuiListItemButton,
	MuiListItemIcon,
	MuiDrawer,
	MuiRadio,
	MuiMonthCalendar,
	MuiPickersMonth,
	MuiCheckbox,
	MuiSwitch,
	MuiPickersDay,
	MuiPopover,
	MuiInputLabel,
};
